import rules from './fieldVisibilityRules';
import { reportBase, cohorts } from './reportsBase';

const TYPE = 'reports';

export default {
    type: TYPE,
    fields: [
        ...reportBase.fields,
        ...cohorts.fields,
        'governanceDimensions',
        'custom_dimensions',
        'xorgMetrics',
        'xorgCohortMetrics',
        'goalsMetrics',
        'goalsForecastMetrics',
        'fileCombinerDimensions',
        'granularityLevels',
        'enrichmentDimensions',
        'trackerData',
        'networkData',
        'discrepancies',
        'videoMetrics',
        'metadataDimensions',
        'creativeMeasurementDimensions',
        'promotedContentDetailsDimensions',
        'sourceAttributionType',
        'utmParamsFields',
        'searchCampaignDimensions',
        'organicInsightsDimensions',
        'attributionInsightsDimensions',
        'appMetrics',
        'webMetrics',
        'withDruidAppend',
        'druidAggregatedDataSourcesMode',
        'crossDeviceDemoCohortType',
        'conversionEvents',
        'socialEngagementMetrics',
        'assistMetrics',
    ],
    visibleRule: rules[TYPE],
    dataSelector: {
        ...reportBase.dataSelector,
        ...cohorts.dataSelector,
        governanceDimensions: 'governanceDimensions',
        custom_dimensions: 'custom_dimensions',
        fileCombinerDimensions: 'fileCombinerDimensions',
        granularityLevels: 'granularityLevels',
        enrichmentDimensions: 'enrichmentDimensions',
        trackerData: 'trackerData',
        networkData: 'networkData',
        discrepancies: 'discrepancies',
        videoMetrics: 'videoMetrics',
        metadataDimensions: 'metadataDimensions',
        creativeMeasurementDimensions: 'creativeMeasurementDimensions',
        promotedContentDetailsDimensions: 'promotedContentDetailsDimensions',
        xorgMetrics: 'xorgMetrics',
        xorgCohortMetrics: 'xorgCohortMetrics',
        goalsMetrics: 'goalsMetrics',
        goalsForecastMetrics: 'goalsForecastMetrics',
        socialEngagementMetrics: 'socialEngagementMetrics',
        assistMetrics: 'assistMetrics',
        sourceAttributionType: 'sourceAttributionType',
        withDruidAppend: 'withDruidAppend',
        druidAggregatedDataSourcesMode: 'druidAggregatedDataSourcesMode',
        crossDeviceDemoCohortType: 'crossDeviceDemoCohortType',
        selectedTab: 'selectedTab',
        transparencyDataFormatted: 'reportData',
        chartDataFormatted: 'chartData',
        chart: 'chart',
        mode: 'mode',
        selectedGoal: 'selectedGoal',
        unenriched: 'unenriched',
        utmParamsFields: 'utmParamsFields',
        searchCampaignDimensions: 'searchCampaignDimensions',
        organicInsightsDimensions: 'organicInsightsDimensions',
        attributionInsightsDimensions: 'attributionInsightsDimensions',
        appMetrics: 'appMetrics',
        webMetrics: 'webMetrics',
        admonAlignment: 'admonAlignment',
        shouldDrilldown: 'shouldDrilldown',
        isSlimMode: 'isSlimMode',
        isClearSelectionOn: 'isClearSelectionOn',
        conversionEvents: 'conversionEvents',
        selectedSources: 'selectedSources',
        selectedApps: 'selectedApps',
    },
};
